import dayjs from 'dayjs';

import * as DateHelper from '../../components/util/DateHelper';
import * as SysConst from '../../components/constants/SystemConstants';
import * as Consts from '../../components/constants/Consts';
import { AuthzIscirAFCode } from '../../components/constants/Consts';
import * as ReminderHelper from './ReminderHelper';



export function generateReminder(autorizatie, preference) {
    let reminder = null;

    if(autorizatie.autorizatie.authISCIR === AuthzIscirAFCode.OperatorRSVTI) {
        reminder = getAuthorizationReminder(autorizatie.autorizatie.dataExpirare, autorizatie.id, autorizatie.autorizatie.authISCIR, preference.offsetAuthorizationRenewal);
    }
    else {
        if(autorizatie.talon){
            if( shouldGenerateReminder(autorizatie.talon.dataVizaTalonAn1, autorizatie.talon.dataVizaTalonAn2) ) {
                reminder = getStampReminder(autorizatie.talon.dataVizaTalonAn1, autorizatie.id, autorizatie.autorizatie.authISCIR, preference.offsetCouponStampRenewal);
            }
            else if( shouldGenerateReminder(autorizatie.talon.dataVizaTalonAn2, autorizatie.talon.dataVizaTalonAn3) ) {
                reminder = getStampReminder(autorizatie.talon.dataVizaTalonAn2, autorizatie.id, autorizatie.autorizatie.authISCIR, preference.offsetCouponStampRenewal);
            }
            else if( shouldGenerateReminder(autorizatie.talon.dataVizaTalonAn3, autorizatie.talon.dataVizaTalonAn4) ) {
                const stampExpirationDate = dayjs(autorizatie.talon.dataVizaTalonAn3).add(SysConst.STAMP_EXPIRATION_YEARS, 'year');
                const couponExpirationDate = dayjs(autorizatie.talon.dataEliberareTalon).add(SysConst.COUPON_EXPIRATION_YEARS, 'year');
                const couponRemDate = dayjs(couponExpirationDate).subtract(preference.offsetCouponRenewal, 'week');

                if( couponRemDate.isBefore(stampExpirationDate)) {
                    reminder = getCouponReminderBasic(autorizatie.talon.dataEliberareTalon, 
                        autorizatie.id, 
                        autorizatie.autorizatie.authISCIR,
                        preference.offsetCouponRenewal);
                }
                else{
                    reminder = getStampReminder(autorizatie.talon.dataVizaTalonAn3, autorizatie.id, autorizatie.autorizatie.authISCIR, preference.offsetCouponStampRenewal);
                }
            }
            else if( shouldGenerateReminder(autorizatie.talon.dataVizaTalonAn4, null) ) {
                reminder = getCouponReminder(autorizatie.talon.dataEliberareTalon, 
                                            autorizatie.talon.dataVizaTalonAn4, 
                                            autorizatie.id, 
                                            autorizatie.autorizatie.authISCIR,
                                            preference.offsetCouponRenewal);
            }
        }
    }

    return reminder;
}


/**
 * Should generate reminder if:
 * - expiration date in the future (no reasons to generate reminders for old stamps)
 * - AND
 * - we do not have a stamp date for 'next' stamp or current stamp is for current year 
 */
const shouldGenerateReminder = (stampDateStr, nextStampDateStr) => {
    if( DateHelper.isValidStringDateFmt(stampDateStr) ) {
        const stampDate = DateHelper.getDateFromString(stampDateStr);
        const stampExpirationDate = stampDate.add(SysConst.STAMP_EXPIRATION_YEARS, 'year');
        if(stampExpirationDate.isAfter(dayjs()) && 
            (!DateHelper.isValidStringDateFmt(nextStampDateStr) || stampDate.isSame(dayjs(), 'year')) ) {
            return true;
        }
        else {
            return false;
        }
    }
    else{
        return false;
    }
}

const getAuthorizationReminder = (dataExpirareAutorizatie, authorizationId, authISCIR, offsetAuthorizationRenewal) => {
    const reminder = { details:{}};
    reminder.details.type = Consts.REMINDER_RENEW_AUTHORIZATION;
    reminder.details.authorizationId = authorizationId;
    reminder.details.authISCIR = authISCIR;

    reminder.details.dataExpirare = ReminderHelper.rollToNextBusinessDay( dayjs(dataExpirareAutorizatie) );
    reminder.details.dataReminder = ReminderHelper.getReminderDate(dataExpirareAutorizatie, offsetAuthorizationRenewal);

    return reminder;
}

const getStampReminder = (stampDate, authorizationId, authISCIR, offsetCouponStampRenewal) => {
    const reminder = { details:{}};
    reminder.details.type = Consts.REMINDER_RENEW_COUPON_STAMP;
    reminder.details.authorizationId = authorizationId;
    reminder.details.authISCIR = authISCIR;

    const stampExpirationDate = dayjs(stampDate).add(SysConst.STAMP_EXPIRATION_YEARS, 'year');
    reminder.details.dataExpirare = ReminderHelper.rollToNextBusinessDay(stampExpirationDate);
    reminder.details.dataReminder = ReminderHelper.getReminderDate(stampExpirationDate, offsetCouponStampRenewal);

    return reminder;
}


/**
 * Calculates the Coupon Reminder Date by using the Coupon Expiration date as a reference
 */
const getCouponReminderBasic = (couponDate, authorizationId, authISCIR, offsetCouponRenewal) => {
    const reminder = { details:{}};
    reminder.details.type = Consts.REMINDER_RENEW_COUPON;
    reminder.details.authorizationId = authorizationId;
    reminder.details.authISCIR = authISCIR;

    const couponExpirationDate = dayjs(couponDate).add(SysConst.COUPON_EXPIRATION_YEARS, 'year');

    reminder.details.dataExpirare = ReminderHelper.rollToNextBusinessDay(couponExpirationDate);
    reminder.details.dataReminder = ReminderHelper.getReminderDate(couponExpirationDate, offsetCouponRenewal);

    return reminder;
}


/**
 * Calculates the Coupon Reminder Date by using the smaller date between 
 * Coupon expiration date and Year 4 expiration date
 */
const getCouponReminder = (couponDate, stampDateYear4, authorizationId, authISCIR, offsetCouponRenewal) => {
    const reminder = { details:{}};
    reminder.details.type = Consts.REMINDER_RENEW_COUPON;
    reminder.details.authorizationId = authorizationId;
    reminder.details.authISCIR = authISCIR;

    const couponExpirationDate = dayjs(couponDate).add(SysConst.COUPON_EXPIRATION_YEARS, 'year');
    const stampExpirationDate = dayjs(stampDateYear4).add(SysConst.STAMP_EXPIRATION_YEARS, 'year');
    var referenceExpirationDate;
    if( couponExpirationDate.isBefore(stampExpirationDate) ) {
        referenceExpirationDate = couponExpirationDate;
    }
    else {
        referenceExpirationDate = stampExpirationDate;
    }

    reminder.details.dataExpirare = ReminderHelper.rollToNextBusinessDay(referenceExpirationDate);
    reminder.details.dataReminder = ReminderHelper.getReminderDate(referenceExpirationDate, offsetCouponRenewal);

    return reminder;
}


export const getAuthzReminder = (reminder) => {
    const authzReminder = {
        type: reminder.details.type,
        dataReminder: reminder.details.dataReminder,
        dataExpirare: reminder.details.dataExpirare
    };

    return authzReminder;
}


export const getReminderExtra = (employee, employer, worksite) => {
    const extra = {
        employeeId: employee.id,
        eFullName: employee.generalSection.lastName + ' ' + employee.generalSection.firstName,
        clientId: employer.generalSection.rsvtiMBClientId,
        employerId: employee.employmentDetails.employerId,
        employerName: employer.generalSection.employerName,
        worksiteId: employee.employmentDetails.workSiteId,
        worksiteName: worksite.generalSection.name + ', ' + worksite.generalSection.localitate
    };

    return extra;
}